import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import {AUTH_ROLES} from '@/app/auth/authRoles';

import IdvDocsPage from './IdvDocsPage';

const IdvDocsRoute: FuseRouteItemType = {
  path: '',
  element: <IdvDocsPage />,
  auth: AUTH_ROLES.parent, // []
  children: [],
};

export default IdvDocsRoute;
